<!--
-@Author: heyu tao
-@since: 2022-07-04 09:33:52
-@LastAuthor: CDS
-@lastTime: 2022-08-04 14:43:16
-@message: file content
-@The path of the file relative to the project: /cds-portal-web/src/views/articles/showPDF.vue
-->
<template>
  <el-dialog top='0vh' :visible.sync="dialogVisible" append-to-body width="100%" >
    <div v-if="fileCurrent.fileType == 'pdf'">
      <pdf
        ref="pdf"
        :src="fileCurrent.fileUrl"
        :page="pageNum"
      
        @num-pages="pageTotalNum=$event"
      />
      <div class="pdf-tab">
        <div
          class="btn-def btn-pre"
          @click.stop="prePage"
        >上一页</div>
        <div class="numPage">{{ pageNum }}/{{ pageTotalNum }}</div>
        <div
          class="btn-def btn-next"
          @click.stop="nextPage"
        >下一页</div>
      </div>
    </div>
    <img v-else :src="fileCurrent.fileUrl" style="display:block;max-width: 100%;margin: 0 auto;">
  </el-dialog>

</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'Detail',
  components: {
    pdf
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      fileCurrent: {},
      pageNum: 1,
      pageTotalNum: 1
    }
  },
  created() {

  },
  methods: {
    init(file) {
      this.dialogVisible = true
      this.fileCurrent = file
    },
    prePage() {
      var p = this.pageNum
      p = p > 1 ? p - 1 : this.pageTotalNum
      this.pageNum = p
    },
    nextPage() {
      var p = this.pageNum
      p = p < this.pageTotalNum ? p + 1 : 1
      this.pageNum = p
    }
  }
}
</script>

<style lang='scss' scoped>
.pdf-tab{
  // display: flex;
  text-align: center;
  .btn-def{
    font-size: 16px;
    margin: 0 10px;
    cursor: pointer;
    display: inline-block;
    padding: 3px 12px;
    background: rgb(245, 249, 255);
    border-radius: 5px;
    height: 32px;
    line-height: 32px;
  }
  .numPage{
    display: inline-block;
    margin: 0 10px;
    font-size: 16px;
    font-weight: 700;
    height: 32px;
    line-height: 32px;
  }
}
</style>
